"use client";

import ReviewsDashboard from "@/modes/agentic-workflows/contract-review/components/ReviewsDashboard";

export default function ContractReviewsIndexPage() {
  return <ReviewsDashboard />;
}
